/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response from toggling Auth0 policyholder permission for a user.
 * @export
 * @interface ControlTogglePolicyholderPermissionResponse
 */
export interface ControlTogglePolicyholderPermissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlTogglePolicyholderPermissionResponse
     */
    user_email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTogglePolicyholderPermissionResponse
     */
    auth0_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTogglePolicyholderPermissionResponse
     */
    had_permission: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTogglePolicyholderPermissionResponse
     */
    has_permission: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTogglePolicyholderPermissionResponse
     */
    action: ControlTogglePolicyholderPermissionResponseActionEnum;
}


/**
 * @export
 */
export const ControlTogglePolicyholderPermissionResponseActionEnum = {
    Added: 'added',
    Removed: 'removed',
    Noop: 'noop'
} as const;
export type ControlTogglePolicyholderPermissionResponseActionEnum = typeof ControlTogglePolicyholderPermissionResponseActionEnum[keyof typeof ControlTogglePolicyholderPermissionResponseActionEnum];


/**
 * Check if a given object implements the ControlTogglePolicyholderPermissionResponse interface.
 */
export function instanceOfControlTogglePolicyholderPermissionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_email" in value;
    isInstance = isInstance && "auth0_id" in value;
    isInstance = isInstance && "had_permission" in value;
    isInstance = isInstance && "has_permission" in value;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function ControlTogglePolicyholderPermissionResponseFromJSON(json: any): ControlTogglePolicyholderPermissionResponse {
    return ControlTogglePolicyholderPermissionResponseFromJSONTyped(json, false);
}

export function ControlTogglePolicyholderPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTogglePolicyholderPermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_email': json['user_email'],
        'auth0_id': json['auth0_id'],
        'had_permission': json['had_permission'],
        'has_permission': json['has_permission'],
        'action': json['action'],
    };
}

export function ControlTogglePolicyholderPermissionResponseToJSON(value?: ControlTogglePolicyholderPermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_email': value.user_email,
        'auth0_id': value.auth0_id,
        'had_permission': value.had_permission,
        'has_permission': value.has_permission,
        'action': value.action,
    };
}

